import styled from "styled-components";

import { colors } from "../../../../styles/figmaColors";
import { typographies } from "../../../../styles/figmaTypographies";
import { StyledColumn } from "../layout";
import { Spacer } from "../../Spacer";
import { TextCapitalized } from "../../text/TextCapitalized";

// Figma "Button" shadow — no shadow token in the design system.
const SHADOW = "0.125rem 0.0625rem 0.25rem 0 rgba(122, 122, 122, 0.08)";

export type WideButtonVariant = "primary" | "secondary";

const VARIANT_STYLES: Record<
  WideButtonVariant,
  { background: string; text: string; border: string }
> = {
  primary: {
    background: colors["colors/button/primary/default"],
    text: colors["colors/text/white"],
    border: colors["colors/button/primary/default"],
  },
  secondary: {
    background: colors["colors/button/tertiary/default"],
    text: colors["colors/text/black"],
    border: colors["colors/borders/button/primary"],
  },
};

export interface WideButtonProps {
  label: string;
  onClick: () => void;
  variant?: WideButtonVariant;
}

export const WideButton = ({
  label,
  onClick,
  variant = "secondary",
}: WideButtonProps) => (
  <StyledButton type="button" onClick={onClick} $variant={variant}>
    <Spacer x={1.5} />
    <StyledColumn>
      <Spacer y={1} />
      <StyledLabel>
        <TextCapitalized>{label}</TextCapitalized>
      </StyledLabel>
      <Spacer y={1} />
    </StyledColumn>
    <Spacer x={1.5} />
  </StyledButton>
);

const StyledButton = styled.button<{ $variant: WideButtonVariant }>`
  /* Reset the native button chrome so spacing comes only from Spacer. */
  all: unset;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 0.0625rem solid ${({ $variant }) => VARIANT_STYLES[$variant].border};
  border-radius: 0.5rem;
  background: ${({ $variant }) => VARIANT_STYLES[$variant].background};
  color: ${({ $variant }) => VARIANT_STYLES[$variant].text};
  box-shadow: ${SHADOW};
  cursor: pointer;
`;

const StyledLabel = styled.div`
  ${typographies["Header/H3"]}
`;
